import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  Alert,
  AlertIcon,
  Image
} from '@chakra-ui/react';
import { useSetRecoilState } from 'recoil';
import { userAtom } from '../state/userAtom';
import { login } from '../api/auth';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const setUser = useSetRecoilState(userAtom);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { user } = await login(email, password);
      setUser(user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="calc(100vh - 200px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={12}
      px={4}
    >
      <Box
        maxW="400px"
        w="100%"
        bg="white"
        p={8}
        borderRadius="lg"
        boxShadow="lg"
      >
        <VStack spacing={6} as="form" onSubmit={handleSubmit}>
          <Image src="/img/iadc-logo.png" alt="IADC" h="50px" />
          <Heading as="h1" size="lg" color="brand.gray">
            Sign In
          </Heading>

          {error && (
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              {error}
            </Alert>
          )}

          <FormControl isRequired>
            <FormLabel color="brand.gray">Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              borderColor="gray.300"
              _focus={{ borderColor: 'brand.red' }}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel color="brand.gray">Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              borderColor="gray.300"
              _focus={{ borderColor: 'brand.red' }}
            />
          </FormControl>

          <Button
            type="submit"
            w="100%"
            bg="brand.red"
            color="white"
            _hover={{ bg: 'brand.darkRed' }}
            isLoading={loading}
          >
            Sign In
          </Button>

          <Text fontSize="sm" color="brand.mediumGray" textAlign="center">
            Contact your administrator if you need access.
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};
